<!--crud dispositivo-->
<script> 
    import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, Container, Row, Card, CardBody } from 'sveltestrap';
    import { fade } from 'svelte/transition';
    import Swal from 'sweetalert2';
  
    let items = [
      { id: 1, codigo: "C001", ip_dispositivo: "192.168.1.1", id_movil: "M001", created: new Date() },
      { id: 2, codigo: "C002", ip_dispositivo: "192.168.1.2", id_movil: "M002", created: new Date() },
      { id: 3, codigo: "C003", ip_dispositivo: "192.168.1.3", id_movil: "M003", created: new Date() },
      { id: 4, codigo: "C004", ip_dispositivo: "192.168.1.4", id_movil: "M004", created: new Date() }
    ];
  
    let showModal = false;
    let selectedItem = null;
    let mode = 'add';
    let formData = {};
  
    const openAddModal = () => {
      mode = 'add';
      formData = {};
      showModal = true;
    };
  
    const openEditModal = (item) => {
      mode = 'edit';
      selectedItem = item;
      formData = { ...item };
      showModal = true;
    };
  
    const saveItem = () => {
      if (mode === 'add') {
        const newItem = {
          ...formData,
          id: Math.max(...items.map(i => i.id), 0) + 1,
          created: new Date(),
        };
        items = [...items, newItem];
      } else {
        items = items.map(item => item.id === selectedItem.id ? { ...item, ...formData } : item);
      }
      showModal = false;
    };
  
    const deleteItem = (id) => {
      Swal.fire({
        title: '¿Estás seguro?',
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminarlo!'
      }).then((result) => {
        if (result.isConfirmed) {
          items = items.filter(item => item.id !== id);
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        }
      });
    };
  </script>
  
  <div class="page-content">
    <Container fluid>
      <div class="breadcrumb-title">
        <h4>DISPOSITIVO</h4>
      </div>
      <Row>
        <div class="col-12">
          <Card>
            <CardBody>
              <div class="table-responsive">
                <Table class="align-middle table-nowrap table">
                  <thead class="table-light">
                    <tr>
                      <th>Código</th>
                      <th>IP Dispositivo</th>
                      <th>Id Móvil</th>
                      <th>Fecha Creación</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {#each items as item (item.id)}
                      <tr transition:fade>
                        <td>{item.codigo}</td>
                        <td>{item.ip_dispositivo}</td>
                        <td>{item.id_movil}</td>
                        <td>{item.created.toLocaleDateString()}</td>
                        <td>
                          <Button color="link" on:click={() => openEditModal(item)}>
                            <i class="bx bx-pencil"></i>
                          </Button>
                          <Button color="link" on:click={() => deleteItem(item.id)}>
                            <i class="bx bx-trash text-danger"></i>
                          </Button>
                        </td>
                      </tr>
                    {/each}
                  </tbody>
                </Table>
              </div>
              <ul class="pagination pagination-rounded justify-content-end mb-2">
                <li class="page-item disabled">
                  <a class="page-link" href="/" aria-label="Previous">
                    <i class="mdi mdi-chevron-left" />
                  </a>
                </li>
                <li class="page-item active">
                  <a class="page-link" href="/">1</a>
                </li>
                <li class="page-item"><a class="page-link" href="/">2</a></li>
                <li class="page-item"><a class="page-link" href="/">3</a></li>
                <li class="page-item"><a class="page-link" href="/">4</a></li>
                <li class="page-item"><a class="page-link" href="/">5</a></li>
                <li class="page-item">
                  <a class="page-link" href="/" aria-label="Next">
                    <i class="mdi mdi-chevron-right" />
                  </a>
                </li>
              </ul>
            </CardBody>
          </Card>
        </div>
      </Row>
    </Container>
  
    <Button color="success" class="floating-button" on:click={openAddModal}>Agregar Nuevo</Button>
  
    <Modal isOpen={showModal} toggle={() => showModal = !showModal}>
      <ModalHeader toggle={() => showModal = !showModal}>
        {mode === 'add' ? 'Nuevo Registro' : 'Editar Registro'}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <label>Código</label>
            <Input bind:value={formData.codigo} required />
          </FormGroup>
          <FormGroup>
            <label>IP Dispositivo</label>
            <Input bind:value={formData.ip_dispositivo} required />
          </FormGroup>
          <FormGroup>
            <label>Id Móvil</label>
            <Input bind:value={formData.id_movil} required />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" on:click={() => showModal = false}>Cancelar</Button>
        <Button color="primary" on:click={saveItem}>Guardar</Button>
      </ModalFooter>
    </Modal>
  </div>
  <style>
    .bx {
      font-size: 1.25rem;
      vertical-align: middle;
    }
    .table th {
      background-color: #f8f9fa;
    }
    .floating-button {
      position: fixed;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 25px;
      padding: 10px 20px;
      font-size: 18px;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
      background-color: #28a745;
      color: white;
    }
  </style>
  